import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const WarrantyTermsPanel = ({ api, productOptions }) => {
  const [d, setD] = useState({ default_months: 12, terms: [] });
  const [dm, setDm] = useState(12);
  const [f, setF] = useState({ product_key: '', months: 24 });
  const load = useCallback(() => api().get('/warranty-terms').then(r => { setD(r.data); setDm(r.data.default_months); }).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);
  const put = async (product_key, months) => {
    try { const r = await api().put('/warranty-terms', { product_key, months: Number(months) }); setD(r.data); toast.success('Warranty saved'); return true; }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); return false; }
  };
  const del = async (k) => { const r = await api().delete(`/warranty-terms/${encodeURIComponent(k)}`); setD(r.data); };
  return (
    <div className="p-4 space-y-4" data-testid="warranty-terms-panel">
      <p className="text-xs text-slate-500">Warranty starts on the ship date (or the serialized date if not shipped yet) and runs for these months.</p>
      <div className="flex items-end gap-2">
        <div><div className="text-xs text-slate-500">Default for all products (months)</div><Input type="number" min={0} value={dm} onChange={(e) => setDm(e.target.value)} className="h-9 w-28 rounded-sm mono" data-testid="wt-default-input" /></div>
        <Button variant="outline" className="rounded-sm" onClick={() => put('*', dm)} data-testid="wt-default-save-btn">Save default</Button>
      </div>
      <div className="flex items-end gap-2 flex-wrap">
        <Input value={f.product_key} onChange={(e) => setF({ ...f, product_key: e.target.value })} list="wt-products" placeholder="Product SKU / name" className="h-9 w-56 rounded-sm mono" data-testid="wt-product-input" />
        <datalist id="wt-products">{(productOptions || []).map(p => <option key={p} value={p} />)}</datalist>
        <Input type="number" min={0} value={f.months} onChange={(e) => setF({ ...f, months: e.target.value })} className="h-9 w-24 rounded-sm mono" data-testid="wt-months-input" />
        <span className="text-xs text-slate-500 pb-2">months</span>
        <Button className="bg-slate-900 hover:bg-slate-800 rounded-sm" disabled={!f.product_key} onClick={async () => { if (await put(f.product_key, f.months)) setF({ product_key: '', months: 24 }); }} data-testid="wt-save-btn">Save product warranty</Button>
      </div>
      <table className="w-full text-sm" data-testid="wt-table">
        <thead><tr className="text-[10px] uppercase text-slate-500 text-left"><th className="py-1">Product</th><th>Months</th><th /></tr></thead>
        <tbody>{d.terms.map((t, i) => (
          <tr key={t.product_key} className="border-t border-slate-100" data-testid={`wt-row-${i}`}>
            <td className="mono py-1.5">{t.product_key}</td><td className="mono">{t.months}</td>
            <td className="text-right"><Button size="sm" variant="ghost" className="h-7 text-red-600" onClick={() => del(t.product_key)} data-testid={`wt-delete-${i}`}>Remove</Button></td>
          </tr>))}
          {!d.terms.length && <tr><td colSpan={3} className="text-xs text-slate-400 py-3">All products use the default.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};

export default WarrantyTermsPanel;
